import React from 'react';
import PropTypes from 'prop-types';

import {Flag} from '@stubhub/bamboo';

import './EventVenueInfo.scss';

const EventVenueInfo = ({
  venueDisplay: {name, location, country, distance},
  disableVenueAndTime,
  showVenueCountryFlag,
}) => {
  if (disableVenueAndTime) {
    return null;
  }

  return (
    <div className="EventItem__MixInfo">
      <span>
        <span className="EventItem__VenueInfo" data-country={country}>
          {showVenueCountryFlag && (
            <Flag
              country={country}
              className="venue-country-flag"
              data-testid="venue-country-flag"
              showFallback={false}
            />
          )}
          {name}, {location}
          {distance && <span className="EventItem__VenueInfo-dist">{distance}</span>}
        </span>
      </span>
    </div>
  );
};

EventVenueInfo.propTypes = {
  venueDisplay: PropTypes.shape({
    /** Name of the venue */
    name: PropTypes.string,

    /** Location of the venue (city, state, etc.) */
    location: PropTypes.string,

    /** Country code of the venue */
    country: PropTypes.string,

    /** Optional distance to the venue */
    distance: PropTypes.string,
  }),

  /**
   * If true, disables rendering of venue and time info
   */
  disableVenueAndTime: PropTypes.bool,

  /**
   * Show venue country flag
   */
  showVenueCountryFlag: PropTypes.bool,
};

export default EventVenueInfo;
